<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>个人事务管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/vacation' }">休假管理</el-breadcrumb-item>
        <el-breadcrumb-item>休假详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="header">
      <div class="header-info">
        <h1>{{ userArr.realname }} {{ userArr.en_name }} </h1>
        <p style="font-size: 20px; font-weight: 550;"></p>
        <p>{{ userArr.department?.en_name }} - {{ userArr.role?.role_name }}</p>
        <p>直属领导：{{ userArr.leader_name }} {{ userArr.leader_en_name }} </p>
        <p>年份：{{ userArr.holiday?.holiday_year }}</p>
      </div>
      <div class="header-status">
        <div>
          <div class="button" :style="{ 'backgroundColor': dd.holidayStatus_c[form.status]?.color }">
            {{ dd.holidayStatus_c[form.status]?.word }}
          </div>
        </div>
      </div>
    </div>
    <!-- 休假信息 -->
    <div class="base1">
      <h3 class="ntitle">休假信息</h3>
      <div class="operater">
        <div class="linkline" @click="handleClick" v-if="NodeInclude('381')">编辑</div>
        <div class="linkbox" @click="showLeaderCheck" style="margin-right: 15px;" v-if="NodeInclude('389') && form.leader_check_status !='2'">主管审核</div>
        <div class="linkbox" @click="showHrCheck" v-if="NodeInclude('390') && form.finance_check_status !='2'">人事审核</div>
      </div>
      <ul>
        <li>
          <p>
            <label>休假类型：</label><a>{{ dd.holidayType[form.holiday_id]}}</a>
          </p>
          <p>
            <label>休假说明：</label><a><pre style="margin: 0; white-space: pre-wrap;">{{ form.reason }}</pre></a>
          </p>
          <p>
            <label>休假起止时间：</label><a>{{ form.start_date }}{{ form.start_time == '1' ? '上午' : '下午' }} - {{ form.end_date }}{{ form.end_time == '1' ? '上午' : '下午' }}</a>
          </p>
          <p>
            <label>主管审核状态：</label>
            <a>
              <div class="circle-tag" :style="{ 'background': dd.leader_check_status_c[form.leader_check_status]?.color }">
                <div class="word">{{ dd.leader_check_status_c[form.leader_check_status]?.word }}</div>
              </div>
            </a>
          </p>
          <p>
            <label>休假证明：</label>
            <template>
              <ul class="bbox">
                <li v-for="(_it, _id) in job_file_list" :key="_id">
                  <template v-if="_it.origin_name">
                    <div class="origin_name" style="width: 600px;">
                      <a style="max-width: 550px;">
                        <div class="origin-name">{{ _it.origin_name }}</div>
                      </a>
                      <a style="width: 50px;">
                        <el-link type="primary" style="margin-right:5px" :href="_it.httpFile" target="_blank">查看</el-link>
                      </a>
                    </div>
                  </template>
                  <el-col v-else>暂无附件</el-col>
                </li>
              </ul>
            </template>
          </p>
        </li>
        <li>
          <!-- 占位符 -->
          <p><label></label><a></a></p>
          <p>
            <label>关联品牌项目：</label>
            <a v-if="form.rest">{{ form.rest?.project_id != '0' ? `${form.rest.project.contract_no}_${form.rest.project.client_company}_${form.rest.project.brand}_${form.rest.project.contract_name}` : `${form.rest.brand.brand}`}}</a>
            <a>暂无</a>
          </p>
          <p>
            <label>申请天数：</label><a>{{ form.apply_days }}天</a>
          </p>
          <p>
            <label>人事审核状态：</label>
            <a>
              <div class="circle-tag" :style="{ 'background': dd.finance_check_status_c[form.hr_check_status]?.color }">
                <div class="word">{{ dd.finance_check_status_c[form.hr_check_status]?.word }}</div>
              </div>
            </a>
          </p>
        </li>
      </ul>
    </div>
    <!-- 职务代理 -->
    <div class="base1" v-if="agentList.length != 0">
      <h3 class="ntitle">职务代理</h3>
      <!-- <div class="operater">
        <div class="linkbox" @click="showAgentCheck" style="margin-right: 15px;">职务代理人审核</div>
      </div> -->
      <template>
        <ul v-for="(item, index) in agentList" :key="`agent_${index}`">
          <li>
            <p>
              <label>代理工作说明：</label><a><pre style="margin: 0;white-space: pre-wrap;">{{ item.work_reason }}</pre></a>
            </p>
            <p>
              <label>职务代理审核状态：</label>
              <a>
                <div class="circle-tag" :style="{ 'background': dd.agent_check_status_c[item.status]?.color }">
                  <div class="word">{{ dd.agent_check_status_c[item.status]?.word }}</div>
                </div>
              </a>
            </p>
            <p v-if="item.agent_info?.id == userId">
              <label></label>
              <a class="linkbox" @click="showAgentCheck" style="margin-right: 15px;">职务代理人审核</a>
            </p>
          </li>
          <li>
            <p>
              <label>职务代理人：</label><a>{{ item.agent_info?.realname }}{{ item.agent_info?.en_name }}</a>
            </p>
          </li>
        </ul>       
      </template>
    </div>
    <!-- 项目动态 -->
    <div class="history">
      <h3 class="ntitle">项目动态</h3>
      <el-form ref="trackForm" :model="trackForm" style="float:right;">
        <el-form-item label="" prop="track_event">
          <el-col :span="20">
            <el-select v-model="trackForm.event_id" placeholder="请选择流程" style="margin-right: 0; width: 100%;"
              @change="trackChange">
              <el-option label="全部流程" value="0"></el-option>
              <el-option label="休假申请" value="15"></el-option>
              <el-option label="休假审核" value="16"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <ul class="linehead">
        <li>时间</li>
        <li>操作人</li>
        <li>流程</li>
        <li>详情</li>
      </ul>
      <div class="timeline">
        <el-timeline>
          <el-timeline-item :timestamp="compDate(item)" placement="top" v-for="(item, index) in myTrackList" :key="index"
            :class="{ child: !item.parent }" :icon="item.icon" :color="item.color">
            <div class="ico-edit">
              <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
                <i class="el-icon-edit" @click="setTimeForm(item)"></i>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="a" v-if="NodeInclude('391')">新增</el-dropdown-item>
                    <el-dropdown-item command="b" v-if="NodeInclude('391')">编辑</el-dropdown-item>
                    <el-dropdown-item command="c" v-if="NodeInclude('392')">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="mycard" :class="{ active: parentActive(item), parent: item.parent }" @click="trigger(item)">
              <!-- {{item}} -->
              <i class="point" v-if="item.point">+{{ item.point }}</i>
              <div v-if="!item.parent">
                <ul class="ul">
                  <li>
                    <span>{{ item.bkUserArr ? item.bkUserArr.realname : '暂无' }}</span>
                  </li>
                  <li>
                    <span>{{ item.eventName }}</span>
                  </li>
                  <li v-html="item.info"></li>
                </ul>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>

    <el-dialog title="职务代理人审核" :visible.sync="agentCheckShow" width="600px">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>休假类型：</span>
          <span>{{ dd.holidayType[form.holiday_id] }}</span>
        </li>
        <li>
          <span>起止时间：</span>
          <span>{{ form.start_date }}{{ form.start_time == '1' ? '上午' : '下午' }} - {{ form.end_date }}{{ form.end_time == '1' ? '上午' : '下午' }}</span>
        </li>
        <li>
          <span>申请天数：</span>
          <span>{{ form.apply_days }}</span>
        </li>
        <li>
          <span>申请人：</span>
          <span>{{ userArr.realname }} {{ userArr.en_name }}</span>
        </li>
        <el-form ref="agentCheckForm" :model="agentCheckForm" label-width="140px" label-position="left" class="ulform">
          <el-form-item label="审核：" prop="status">
            <el-col :span="24">
              <el-radio-group v-model="agentCheckForm.status">
                <el-radio label="1">通过</el-radio>
                <el-radio label="2">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <el-form-item label="" prop="reason">
            <el-col :span="24">
              <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                v-model="agentCheckForm.reason">
              </el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="agentCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handleAgentCheck">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="主管审核" :visible.sync="leaderCheckShow" width="600px">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>休假类型：</span>
          <span>{{ dd.holidayType[form.holiday_id] }}</span>
        </li>
        <li>
          <span>起止时间：</span>
          <span>{{ form.start_date }}{{ form.start_time == '1' ? '上午' : '下午' }} - {{ form.end_date }}{{ form.end_time == '1' ? '上午' : '下午' }}</span>
        </li>
        <li>
          <span>申请天数：</span>
          <span>{{ form.apply_days }}</span>
        </li>
        <li>
          <span>申请人：</span>
          <span>{{ userArr.realname }} {{ userArr.en_name }}</span>
        </li>
        <el-form ref="leaderCheckForm" :model="leaderCheckForm" label-width="140px" label-position="left" class="ulform">
          <el-form-item label="审核：" prop="status">
            <el-col :span="24">
              <el-radio-group v-model="leaderCheckForm.status">
                <el-radio label="1">通过</el-radio>
                <el-radio label="2">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <el-form-item label="" prop="reason">
            <el-col :span="24">
              <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                v-model="leaderCheckForm.reason">
              </el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="leaderCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handleLeaderCheck">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="人事审核" :visible.sync="hrCheckShow" width="600px">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>休假类型：</span>
          <span>{{ dd.holidayType[form.holiday_id] }}</span>
        </li>
        <li>
          <span>起止时间：</span>
          <span>{{ form.start_date }}{{ form.start_time == '1' ? '上午' : '下午' }} - {{ form.end_date }}{{ form.end_time == '1' ? '上午' : '下午' }}</span>
        </li>
        <li>
          <span>申请天数：</span>
          <span>{{ form.apply_days }}</span>
        </li>
        <li>
          <span>申请人：</span>
          <span>{{ userArr.realname }} {{ userArr.en_name }}</span>
        </li>
        <el-form ref="hrCheckForm" :model="hrCheckForm" label-width="140px" label-position="left" class="ulform">
          <el-form-item label="审核：" prop="status">
            <el-col :span="24">
              <el-radio-group v-model="hrCheckForm.status">
                <el-radio label="1">通过</el-radio>
                <el-radio label="2">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <el-form-item label="" prop="reason">
            <el-col :span="24">
              <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                v-model="hrCheckForm.reason">
              </el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hrCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handleHrCheck">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="timeForm.option == 1 ? '新增休假动态' : '编辑休假动态'" :visible.sync="trackShow" width="600px">
      <el-form ref="timeForm" :model="timeForm" label-width="140px" label-position="left" class="ulform">
        <el-form-item label="选择时间：" prop="create_time">
          <el-col :span="24">
            <el-date-picker v-model="timeForm.create_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择时间" style="width:100%;">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="选择操作人：" prop="bk_uid">
          <el-col :span="24">
            <el-select v-model="timeForm.bk_uid" placeholder="请选择" clearable filterable style="width:100%;">
              <el-option :label="`${v.en_name} ${v.realname}`" :value="v.id" v-for="(v, i) in userList"
                :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="选择流程：" prop="event_id">
          <el-col :span="24">
            <el-select v-model="timeForm.event_id" placeholder="请选择" style="width: 100%;">
              <el-option label="全部流程" value="0"></el-option>
              <el-option label="休假申请" value="15"></el-option>
              <el-option label="休假审核" value="16"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="备注：" prop="info">
          <el-col :span="24">
            <el-input style="width: 100%;" type="textarea" spellcheck="false" :autosize="{ minRows: 4 }"
              placeholder="请输入内容" v-model="timeForm.info">
            </el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="trackShow = false">取 消</el-button>
        <el-button type="primary" @click="handleTrack">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="删除休假动态" :visible.sync="delTrackShow" width="600px">
      <ul class="aul ulist" style="padding:0; min-height: 100px;">
        <li>
          <span>时间：</span>
          <span>{{ timeForm.create_time }}</span>
        </li>
        <li>
          <span>操作人：</span>
          <span>{{ timeForm.bkUserArr ? timeForm.bkUserArr.realname : '暂无' }}</span>
        </li>
        <li>
          <span>项目状态：</span>
          <span>{{ dd.track_type[timeForm.event_id] }}</span>
        </li>
        <li>
          <span>详情：</span>
          <span v-html="timeForm.info"></span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delTrackShow = false">取 消</el-button>
        <el-button type="primary" @click="deleteTrack">确 定</el-button>
      </span>
    </el-dialog>

  </el-main>
</template>

<script>
import * as api from '@/api'
import store from '@/store'
// import { thousands } from '@/utils/index.js'
export default {
  name: 'expenseView',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      userId: '',
      mType: '5',
      userArr: {},
      userList: [],
      form: {
        holiday_detail_id: '', //员工休假id
        is_creat: '',
        is_draft: '',
        user_id: '', //user_id
        holiday_id: '1',
        reason: '',
        start_date: '',
        start_time: '',
        end_date: '',
        end_time: '',
        apply_days: '',
        is_replace: '',// 待补假标识 （区分正常请假和他人代补假）
        status: '',
        approval_status: '',
      },
      agentCheckShow: false,
      agentCheckForm: {
        status: '2', //1审核通过 2审核不通过
        reason: '',
      },
      leaderCheckShow: false,
      leaderCheckForm: {
        status: '2', //1审核通过 2审核不通过
        reason: '',
      },
      hrCheckShow: false,
      hrCheckForm: {
        status: '2', //1审核通过 2审核不通过
        reason: '',
      },
      trackForm: {
        project_id: '',
        event_id: '',
      },
      delTrackShow: false,
      timeForm: {
        track_id: '',
        create_time: '',
        bk_uid: '',
        event_id: '',
        info: '',
        option: 1,
      },
      trackList: [],
      trackShow: false,
      currTrack: {//当前动态

      },
      job_file_list: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] },
      ],
      holidayDetail: {},
      typeList: [],
      del_job_list: [],
      canAgentList: [],
      agentList: [
        { id: '', agent_id: '', work_reason: '' },
      ],
      del_agent_list: [],
    }
  },
  computed: {
    parentActive() {
      return (item) => {
        return item.parent && item.active
      }
    },
    myTrackList() {
      return this.trackList.filter((item) => item)
    },
  },
  created() {
    this.query = this.$route.query
    this.query.id && this.getDetail(this.query.id)
  },
  mounted() {
    this.getUserList()
  },
  watch: {
    
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },

    async getUserList() {
      this.$fly
        .post('apiAccount_getUserList.html', {
          per_page: 5000,
        })
        .then((res) => {
          this.userList = res.itemList
        })
    },

    async getUserDetail(uid) {
      this.$fly
        .post('ApiStaffReimbursement_getStaffInfo.html', {
          uid: uid,
        })
        .then((res) => {
          this.userArr = res
        })
    },

    async geHolidayInfo(holiday_id) {
      let postData = {
        holiday_id,
      }
      api.getHolidayInfo(postData).then((res) => {
        this.holidayDetail = res
      })
    },

    async getHolidayType(uid, is_replace) {
      let postData = {
        user_id: uid,
        is_replace: is_replace,
      }
      api.getHolidayType(postData).then((res) => {
        this.typeList = res
      })
    },

    async getAgentList() {
      api.getAgentList({
        user_id: this.form.user_id,
      }).then((res) => {
        this.canAgentList = res
      })
    },
    getDetail(id) {
      api.getStaffHolidayDetail({
        holiday_detail_id: id,
      }).then((res) => {
        const {
          is_creat,
          is_draft,
          is_replace,
          holiday_id,
          reason,
          start_date,
          start_time,
          end_date,
          end_time,
          days,
          user_info,
          leader_check_status,
          hr_check_status,
          status,
          rest,
          approval_status,
        } = res
        this.form = {
          holiday_detail_id: id,
          is_creat,
          is_draft,
          is_replace,
          holiday_id,
          reason,
          start_date,
          start_time,
          end_date,
          end_time,
          apply_days: days,
          user_id: user_info.id,
          leader_check_status,
          hr_check_status,
          status,
          rest,
          approval_status,
        }
        this.trackList = res.track_list
        this.getUserDetail(user_info.id )
        this.geHolidayInfo(holiday_id)
        this.job_file_list = res.staff_holiday_file.map(({origin_name, file_name, httpFile, id}) => {
          return {origin_name, file_name, httpFile, file_id: id, fileList: []}
        })
        this.agentList = res.job_agency_arr.map(({id, agency_id, work_reason, status, agent_info}) => {
          return {id, agent_id: agency_id, work_reason, status, agent_info}
        })
        this.getStoreFn()
      })
    },

    getStoreFn () {
      this.checkUrlFn()
      this.checkNodeFn('61')
      setTimeout(() => {
        //权限
        this.level = store.state.level
        this.userId = store.state.userId
        if (this.userId != this.form.user_id) {
          this.form.is_replace = '1'
        }
        this.getHolidayType(this.form.user_id, this.form.is_replace)
        this.getAgentList()// 获取代理人下拉列表
      }, 200);
    },
    compDate(item) {
      return item.smartTime + '' + item.weekTime
    },
    trigger(item) {
      let date = item.date || {}
      this.trackList = this.trackList.map((v) => {
        if (v.date === date) {
          v.active = !v.active
        }
        return v
      })
    },
    trackChange(v) {
      this.$fly
        .post('ApiHoliday_getTrackList', {
          project_id: this.query.id,
          event_id: v,
        })
        .then((res) => {
          this.trackList = res.trackList
        })
    },
    //修改项目动态
    setTimeForm(item) {
      console.log(item);
      const { bk_uid, create_time, event_id, id, info, bkUserArr } = item
      this.timeForm = {
        track_id: id,
        bk_uid,
        create_time,
        event_id,
        info,
        bkUserArr,
      }
    },
    handleCommand(command) {
      if (command == 'a') {
        this.timeForm = {
          track_id: '',
          bk_uid: '',
          create_time: '',
          event_id: '',
          info: '',
        }
        this.timeForm.option = 1
        this.timeForm.project_id = this.form.id
        this.trackShow = true
      }
      else if (command == 'b') {
        delete this.timeForm.bkUserArr
        this.timeForm.option = 2
        this.trackShow = true
      }
      else if (command == 'c') {
        console.log('c');
        this.delTrackShow = true
      }
    },
    handleTrack() {
      this.$fly
        .post('ApiStaffReimbursement_editTrackInfo.html', {
          ...this.timeForm,
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          this.trackShow = false
          this.query.id && this.getDetail(this.query.id)
        })
    },
    deleteTrack() {
      this.$fly
        .post('ApiStaffReimbursement_delTrack.html', {
          track_id: this.timeForm.track_id,
          mType: this.mType,
        })
        .then(() => {
          this.delTrackShow = false
          this.query.id && this.getDetail(this.query.id)
        })
    },
    handleClick() {
      if (this.form.is_replace == '1' && (this.form.holiday_id != '6' && this.form.holiday_id != '7' && this.form.holiday_id != '8') && this.level != '1') {
        this.$message.error('代补假只能编辑事假、病假、丧假!')
        return false;
      }
      if (!this.judgetMent(this.form)) {
        this.$message.error('该申请未提交、正在审核中或已完成！')
        return false;
      }
      this.$router.push({
        path: '/vacation/add',
        query: { id: this.form.holiday_detail_id },
      })
    },
    showAgentCheck() {
      this.agentCheckShow = true
    },
    handleAgentCheck() {
      this.holidayReviewFn('3')
    },
    showLeaderCheck() {
      this.leaderCheckShow = true
    },
    handleLeaderCheck() {
      this.holidayReviewFn('1')
    },
    showHrCheck() {
      this.hrCheckShow = true
    },
    handleHrCheck() {
      this.holidayReviewFn('2')
    },
    holidayReviewFn(audit_type) {
      let postData = {
        holiday_detail_id: this.form.holiday_detail_id,
        audit_type,
      }
      if (audit_type == '1') {
        postData = {...postData, ...this.leaderCheckForm}
      } else if (audit_type == '2') {
        postData = {...postData, ...this.hrCheckForm}
      } else if (audit_type == '3') {
        postData = {...postData, ...this.agentCheckForm}
      }
      api.holidayReview(postData).then(() => {
        this.agentCheckShow = false
        this.leaderCheckShow = false
        this.hrCheckShow = false
          //还原审核状态
        this.agentCheckForm = {
          reason: '',
          status: '2',
        }
        this.leaderCheckForm = {
          reason: '',
          status: '2',
        }
        this.hrCheckForm = {
          reason: '',
          status: '2',
        }
        this.query.id && this.getDetail(this.query.id)
      })
    },
    judgetMent(obj) {
      //approval_status申请了0就变1，代理人全同意变2，领导同意变3，财务同意变4，任意不同意变0
      if (obj.is_draft == '1') { //草稿
        return true //可编辑
      }
      else {
        console.log(obj.approval_status);
        if (obj.approval_status == '0') {
          
          
          return true //可编辑
        }
        else {
          return false //可编辑
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  //标题样式
  @extend %box;
  box-sizing: border-box;
  width: 100%;
  background: var(--card); /* 0819修改 */
  padding: 20px 40px;
  margin-bottom: 10px;
  @extend %center;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;

  .header-info {
    width: 80%;
    @extend %center;
    align-items: flex-start;
    text-align: left;

    h1 {
      font: 700 28px/1 $font;
      margin-bottom: 16px;
    }

    p {
      font: 16px/2 $font;

      &.info-detail {
        color: #999;
        font: 12px/2 $font;
        white-space: pre-wrap;
      }

      &.pdou {
        span {
          &::after {
            content: ',';
            display: inline-block;
          }

          &:last-of-type {
            &::after {
              display: none;
            }
          }
        }
      }
    }
  }

  .header-status {
    @extend %center;
    flex-flow: row nowrap;

    .button {
      box-sizing: border-box;
      min-width: 100px;
      border-radius: 20px;
      padding: 10px 15px;
      font: 12px/1 $font;
      color: #fff;
    }
  }
}

.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .filterwrap {
    display: flex;
    justify-content: flex-end;
    padding: 0 0 15px 0;

    .el-button {
      margin: 0 0 0 20px;
    }
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    .ntitle {
      display: inline-block;
      margin: 0 0 25px 0;

      &::before {
        width: 100%;
      }
    }

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      background: var(--bg-soft); /* 0819修改 */
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }

          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }

          .anlist {
            padding: 0;
            width: 100%;
            flex-flow: column nowrap;

            li {
              position: relative;
              width: 100%;

              .bbtn {
                position: absolute;
                top: 50%;
                left: 100%;
                transform: translateY(-50%)
              }
            }
          }

        }
      }
    }
  }
}

.aul.ulist {
  padding: 20px 0;
  font: 14px/2 $font;
  text-align: left;

  >li {
    padding: 0 60px;
    display: flex;
    flex-flow: row nowrap;

    span {
      display: inline-block;

      &:first-of-type {
        width: 30%;
      }

      &:last-of-type {
        width: 70%;
      }
    }
  }

  .ulform {
    padding: 0 60px;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        cursor: pointer !important;

        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 14px;
        color: #606266;
      }
    }

    span {
      color: var(--text-1); /* 0819修改 */;
      font-size: 16px;
      padding: 0 5px;
    }
  }
}

.inblank {
  @extend %center;
  font: 14px/2 $font;
  color: #999;
  background: var(--bg-soft); /* 0819修改 */
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 20px;
  position: relative;
}

.operater {
  @extend %start;
  position: absolute;
  top: 30px;
  right: 40px;
  font: 14px/1 $font;
  text-align: center;

  >div {
    min-width: 32px;
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    padding: 9px 10px;
    cursor: pointer;

    &.linkline {
      border-color: transparent;
      background: transparent;
      color: var(--text-1); /* 0819修改 */;

      &:hover {
        &::after {
          display: block;
          content: '';
          height: 0.1px;
          background: #231f20;
        }
      }
    }

    &.linkbox {
      border-color: #0E0F22;
      background: #0E0F22;
      color: #fff;

      &.grey {
        border-color: #c0c4cc;
        background: #c0c4cc;
        color: #fff !important;

        &:hover {
          background: #c0c4cc;
        }
      }

      &:hover {
        background: rgba($color: #0E0F22, $alpha: 0.8);
      }
    }
  }
}

.circle-tag {
  position: relative;
  top: 11px;

  &:hover {
    .word {
      padding: 0 10px;
    }
  }
}

.dialog-download {
  border-radius: 12px;
  background: #231f20;
  font: 12px/2 $font;
  color: #fff;
  padding: 5px 20px;
  margin: 0 20px;

  &:hover {
    color: #fff;
    background: rgba($color: #0E0F22, $alpha: 0.8);

    &::after {
      display: none;
    }
  }
}


.table {
  position: relative;
  margin-bottom: 20px;

  .expense {
    @extend %start;
    padding: 30px 0;

    >div {
      margin-right: 30px;
    }
  }

  .operater {
    .button {
      box-sizing: border-box;
      min-width: 100px;
      border-radius: 20px;
      padding: 10px 15px;
      font: 12px/1 $font;
      color: #fff;
      cursor: default;
    }
  }
}

.download {
  padding: 10px 0;
  @extend %start;
  justify-content: flex-end;
}

.history {
  @extend %box;
  padding: 30px 40px;
}
</style>

<style lang="scss">
.linehead {
  //时间版头样式
  display: flex;
  flex-flow: row nowrap;
  font: 16px/1 $font;
  color: var(--text-1); /* 0819修改 */
  padding: 25px 55px 0 60px;

  li {
    flex: auto;

    &:nth-child(1) {
      width: 190px;
      flex: none;
    }

    &:nth-child(2) {
      width: 190px;
      flex: none;
    }

    &:nth-child(3) {
      width: 190px;
      flex: none;
    }

    &:nth-child(4) {
      width: 880px;
      flex: none;
    }
  }
}

.timeline {
  //时间版内样式
  margin: 20px 25px 20px 30px;
  padding: 50px 30px;
  border-radius: 6px;
  border: solid 1px #bfbfbf;

  .ico-edit {
    display: block;
    width: 20px;
    height: 20px;
    z-index: 999 !important;
    position: absolute;
    left: -160px;
    top: 0px;
    cursor: pointer;

    ::before {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }
  }

  .mycard {
    min-height: 80px;
    background-color: var(--card); /* 0819修改 */
    border-radius: 4px;
    padding: 0 20px;
    position: relative;
    transform: translateY(-20px);
    // pointer-events: none;

    &.parent {
      pointer-events: auto;
      // cursor: pointer;
    }

    &.active {
      background-color: var(--card); /* 0819修改 */
      height: 30px;

      &:before {
        display: none;
      }

      dl,
      .point {
        display: none;
      }
    }

    &:before {
      content: '';
      font-size: 0;
      border-bottom: 20px solid #f5f5f5;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid transparent;
      position: absolute;
      top: 0;
      left: -10px;
    }

    dl {
      flex: none;
      display: flex;
      height: 80px;
      flex-flow: column wrap;
      padding: 10px 60px 10px 00px;
      flex-flow: row nowrap;

      dd {
        height: 60px;
        width: 150px;

        &:nth-child(2) {
          width: 180px;
        }

        flex: none;
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: center;

        span {
          font: 14px/30px $font;
        }
      }
    }

    .ul {
      padding: 0;
      display: flex;
      flex-flow: row nowrap;
      position: relative;
      z-index: 999;

      li {
        @extend %center;
        align-items: flex-start;
        min-height: 80px;
        flex: auto;
        font: 14px/20px $font;

        &:nth-child(1) {
          width: 180px;
          flex: none;
        }

        &:nth-child(2) {
          width: 180px;
          flex: none;
        }

        &:nth-child(3) {
          padding-left: 20px;
          display: flex;
          flex-flow: column nowrap;
          padding: 10px 60px 10px 20px;
          box-sizing: border-box;
          text-align: left;

          span {
            font: 14px/30px $font;

            &.grey {
              font-size: 14px;
              color: #999;
            }
          }

          a {
            display: inline-block;
            position: relative;
            z-index: 999999999999999999 !important;
            cursor: pointer;
          }
        }
      }
    }

    .point {
      position: absolute;
      background: $c;
      color: #fff;
      height: 30px;
      font: 16px/30px $font;
      padding: 0 10px;
      border-radius: 15px;
      right: 30px;
      top: 25px;
    }

    .ticon {
      position: absolute;
      left: -160px;
      height: 30px;
      line-height: 30px;
      padding: 0 20px 0 88px;
      color: #fff;
      top: 14px;
    }
  }

  .el-timeline {
    padding-left: 140px;

    .el-timeline-item {
      position: relative;
    }
  }

  .child {
    .el-timeline-item__timestamp.is-top {
      background-color: var(--card); /* 0819修改 */
      color: #9c9a9a;
      text-align: right;
    }
  }

  .el-timeline-item__timestamp.is-top {
    position: absolute;
    left: -140px;
    width: 120px;
    height: 30px;
    background-color: #2696d2;
    border-radius: 4px;
    color: #fff;
    font: 14px/30px $font;
    padding: 0 0 0 10px;
    top: -6px;
    box-sizing: border-box;
  }
}

.pdou {
  span {
    &::after {
      content: ',';
      display: inline-block;
    }

    &:last-of-type {
      &::after {
        display: none;
      }
    }
  }
}

.origin_name {
  @extend %start;

  >a {
    text-align: center;
  }
}

.inner {
  display: block;
  min-height: 23px;

  span {
    margin-right: 10px;
    font-size: 12px;
    display: inline-block;
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }

}

.linkbox {
  min-width: 32px;
  height: 20px;
  line-height: 20px;
  border: 1px solid #DCDFE6;
  border-radius: 3px;
  padding: 4px 5px;
  cursor: pointer;
  border-color: #0E0F22;
  background: #0E0F22;
  color: #fff;

  &.grey {
    border-color: #c0c4cc;
    background: #c0c4cc;
    color: #fff !important;

    &:hover {
      background: #c0c4cc;
    }
  }

  &:hover {
    background: rgba($color: #0E0F22, $alpha: 0.8);
  }
}
</style>
